import { Box, Paper, Typography, IconButton } from "@mui/material";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import makeStyles from '@mui/styles/makeStyles';
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ListagemItem } from "src/components/projetos/types";

export interface InverterListMobileProps {
  titulo?: string;
  inversoresList: ListagemItem[];
  handleChangeInverterQuantity: (id: number, value: string) => void;
  handleOpenModalDadosTecnicos?: ({ detalhesComponenteId }: { detalhesComponenteId?: number }) => void;
}

const useStyles = makeStyles({
  container: {
    width: '100%'
  },

  title: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 20,
    textAlign: "left",
  },

  card: {
    padding: 15,
    borderRadius: 12,
    marginBottom: 25,
  },

  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    paddingLeft: 5
  },

  componenteInfo: {
    flex: 1,
    textAlign: "left",
  },

  infoTexto: {
    marginBlock: 3
  },

  attention: {
    color: "#c47a00",
    fontWeight: 600,
  },

  inputQuantidade: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    position: "relative",
    left: "-20px"
  },

  detailsButton: {
    textAlign: "right",
    position: "relative",
    top: 3,
  },

  rowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15
  }
});

export default function InversoresListMobile({
  titulo,
  inversoresList,
  handleOpenModalDadosTecnicos,
  handleChangeInverterQuantity,
}: InverterListMobileProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {titulo && <Typography className={classes.title}>{titulo}</Typography>}
      {inversoresList?.map((row) => (
        <Paper key={row.componente_id} className={classes.card} elevation={1}>
          <Box className={classes.cardHeader}>
            <Box className={classes.componenteInfo}>
              <Typography variant="body1" style={{ fontWeight: 600 }} className={classes.infoTexto}>
                {row.nome}
              </Typography>

              {row.descricao && (
                <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                <span className={classes.attention}>Informações</span>: {row.descricao}
                </Typography>
              )}
            </Box>
          </Box>

          <Box className={classes.rowBox}>
            <Box className={classes.inputQuantidade}>
              <InputQuantidade
                value={row?.quantidade || 0}
                onChange={(value: string) =>
                  handleChangeInverterQuantity(row.componente_id, value)
                }
              />
            </Box>

            <Box className={classes.detailsButton}>
              <IconButton
                onClick={() => {
                  if (handleOpenModalDadosTecnicos) {
                    handleOpenModalDadosTecnicos({ detalhesComponenteId: row.componente_id })
                  } else {
                    modalComponentesDetalhesData$.next(row.componente_id)
                  }
                }}
                size="large">
                <FindInPageOutlined htmlColor="black" fontSize="large" />
              </IconButton>
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}